import React, { useState, useEffect, useContext } from "react";
import Scroll from "../../shared/components/navigation/Scroll";

import SearchBox from "../components/SearchBox.js";
import { AuthContext } from '../../shared/context/auth-context';

import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "../../shared/hooks/http-hook";
import Table from "../../shared/components/Table/Table";
import { CustomerTableHeaders } from "../components/CustomerTableHeaders";
import { formatPhoneNumber } from "../../print/page/Print";
import "tachyons";
import "../pages/Customers.css";
import  FloatingButton  from "../../shared/components/UIElements/FloatingButton";

const Customers = () => {
  const [loadedCustomers, setLoadedCustomers] = useState([]);
  const [searchfield, setSearchfield] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const auth = useContext(AuthContext);
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+"/customers",
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedCustomers(responseData.customers);
      } catch (err) {}
    };
    fetchCustomers();
  }, [sendRequest, auth.token]);

  
  const filteredUsers = loadedCustomers.filter((user) => {
    return (
      user.name.toLowerCase().includes(searchfield.toLowerCase()) ||
      user.lastname.toLowerCase().includes(searchfield.toLowerCase()) ||
      String(user.phone).includes(searchfield) ||
      user.address.toLowerCase().includes(searchfield.toLowerCase())
    );
  }).map(customer => {
    return({
      ...customer,
      phone : formatPhoneNumber(customer.phone),
      address : customer.address.length > 20 ? customer.address.slice(0, 20) + "..." : customer.address
    })
  }).reverse()

  const onSearchChange = (event) => {
    setSearchfield(event.target.value);
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <div className="tc">
        <div style={{ display: "inline-block" }}>
          <SearchBox searchChange={onSearchChange} />
        </div>
      </div>

      <Scroll>
          {!isLoading && filteredUsers && (
              <Table headers={CustomerTableHeaders} content={filteredUsers} />
          )}
      </Scroll>
      <FloatingButton route={"/customers/new"} />
    </React.Fragment>
  );
};

export default Customers;
